/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import receiveLocationWebsites from './receive-location-websites';
import * as actions from 'state/action-types';

export default (locationWebsiteId = null, locationWebsite) => (dispatch) => {
    const isNew = !locationWebsiteId;
    if (isNew) {
        return cecSdk
            .locationWebsite()
            .add(locationWebsite)
            .then((locationWebsite) => {
                dispatch(receiveLocationWebsites([locationWebsite]));
                dispatch({ type: actions.SAVE_LOCATION_WEBSITE_SUCCESS, payload: { locationWebsite, isNew } });
            });
    }

    return cecSdk
        .locationWebsite(locationWebsiteId)
        .update(locationWebsite)
        .then((locationWebsite) => {
            dispatch(receiveLocationWebsites([locationWebsite]));
            dispatch({ type: actions.SAVE_LOCATION_WEBSITE_SUCCESS, payload: { locationWebsite } });
        });
};